export default __webpack_public_path__ + "static/media/dfl-3-rMAX.95c8edad.avif";